import styles from 'components/chat-components/AgentMessage.module.css'

import type { FunctionCallContent } from 'components/chat-components/AgentMessage.types'
import type { ReactElement } from 'react'

export const FunctionCallRenderer = ({ content }: { content: FunctionCallContent }): ReactElement => {
  /* --- Section 6: Render --- */
  return (
    <div className={styles.contentFunctionCall}>
      <span className={styles.functionCallIcon}></span>
      <span className={styles.functionCallName}>{content.name}</span>
      <code className={styles.functionCallArgs}>{JSON.stringify(content.arguments)}</code>
    </div>
  )
}
